<template>
  <a class="ref" v-if="id" ref="trigger" :class="type" href="#" tabindex="0" @click.prevent="">
    <slot>
      <i class="fa fa-info-circle fa-fw bg-white text-primary"></i>
    </slot>
    <b-popover :target="() => $refs.trigger" placement="auto" triggers="click blur">
      <note :id="id"/>
    </b-popover>
  </a>
</template>
<script>
  import uniq from 'lodash/uniq'
  import Note from './Note'

  export default {
    components: {Note},
    props: {
      id: {type: Array}
    },
    computed: {
      type() {
        return uniq(this.id.map(id => this.$store.state.notes[id].class)).join(' ')
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import "app/javascript/scss/variables";

  .ref {
    text-decoration: none;
    color: initial;

    &.Note > :not(.fa-info-circle) {
      @include note-style;
    }

    &.Variants > :not(.fa-info-circle) {
      @include variant-style;
    }
  }
</style>
